import { all } from 'redux-saga/effects'
import user from './user/sagas'
import register from './register/saga'
import settings from './settings/sagas'
import dashboard from './dashboard/saga'
import general from './general/saga'

import trades from './trades/saga'
import newTrade from './newTrade/saga'
import trade from './trade/saga'
import chat from './chat/saga'
import upload from './upload/saga'
import beneficiary from './beneficiary/saga'

import reports from './reports/sagas'
import notifications from './notifications/saga'

import currencyAccounts from './currecnyAccounts/saga'
import digitalPayment from './digitalPayment/saga'
import caTransactions from './caTransactions/saga'
import caBalanceAdjustments from './caBalanceAdjustments/saga'

export default function* rootSaga() {
  yield all([
    user(),
    settings(),
    dashboard(),
    general(),
    trades(),
    newTrade(),
    trade(),
    chat(),
    upload(),
    beneficiary(),
    reports(),
    notifications(),
    currencyAccounts(),
    register(),
    caTransactions(),
    caBalanceAdjustments(),
    digitalPayment(),
  ])
}
